<div class="container">
  <h1>Welcome to Cerberus</h1>
  <p class="subtitle">Looks like you don't have access to Cerberus yet.</p>
  <p>
    To request access, please follow the instructions below. Once your access
    has been approved, contact your administrator to configure your profile.
  </p>
  <a
    href="https://aznextgen.service-now.com/esc?id=kb_article&sysparm_article=KB0062663&table=kb_knowledge&searchTerm=cerberus"
    target="_blank"
    >Click here to view roles and instructions to request access through
    SailPoint.</a
  ><br /><br />
  <a
    href="https://astrazeneca.identitynow.com/ui/d/mysailpoint"
    target="_blank"
    class="secondary"
  >
    Request Access
  </a>
</div>
